export enum FeatureFlagNames {
  EnableAppLauncherWidget = 'feature/enable_app_launcher_widget',
  EnableAppLauncherWidgetEXC = 'feature/exc/enable_app_launcher_widget'
}
